// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';

import './NewCardSettingModal.css';

// React Modalで実装
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";

Modal.setAppElement("#root");

const NewCardSetting2 = ({modalIsOpen, closeModal, movePrevPage, currentCard, setCurrentCard, selectedOption, previewImage, saveCard}) => {
    const { t } = useTranslation();

    const submitRegister = () => {
        let isSaved = saveCard();
        if (isSaved) {
            closeModal();
        } else {
            // alert("カードの登録に失敗しました。");
        }
    }

    return (
        <>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="new-card-setting-modal"
            overlayClassName="new-card-setting-modal-overlay"
            contentLabel="Example Modal"
        >
            <div className="new-card-setting-modal-title">{t('new_card_setting2.title')}</div>
            <div className='progressbar-mini-box'>
                <ul className="progressbar-mini">
                    <li className="active"></li>
                    <li className="active"></li>
                </ul>
            </div>
            <div className="clearfix"></div>
            <div className="new-card-setting-modal-form">
                <dl className="oripa-info-confirm oripa-info-modal-dl-half">
                    <dt className="oripa-info-modal-dl-title">{t('new_card_setting2.image')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <img src={previewImage} className="new-card-setting-modal-form-preview-image" />
                    </dd>
                </dl>
                <div className="clearfix"></div>
                <dl className="oripa-info-confirm">
                    <dt className="oripa-info-modal-dl-title clear-left">{t('new_card_setting2.name')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <input type="text" className="oripa-info-modal-dl-input" value={currentCard.name} onChange={(e) => setCurrentCard({...currentCard, name: e.target.value})} />
                    </dd>
                </dl>
                <div className="clearfix"></div>
                <div className="line"></div>
                <dl className="oripa-info-confirm">
                    <dt className="oripa-info-modal-dl-title">{t('new_card_setting2.rank')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <select className="oripa-info-modal-dl-select" value={currentCard.rank} onChange={(e) => setCurrentCard({...currentCard, rank: e.target.value})}>
                            <option value="1">{t('new_card_setting2.rank1')}</option>
                            <option value="2">{t('new_card_setting2.rank2')}</option>
                            <option value="3">{t('new_card_setting2.rank3')}</option>
                            <option value="4">{t('new_card_setting2.rank4')}</option>
                            <option value="9">{t('new_card_setting2.rank5')}</option>
                        </select>
                    </dd>
                    {currentCard.rank === '9' ?
                        <>
                            <dt className="oripa-info-modal-dl-title clear-left">{t('new_card_setting2.rank5')}</dt>
                            <dd className="oripa-info-modal-dl-text">
                                <input type="text" className="oripa-info-modal-dl-input" value={currentCard.number} onChange={(e) => setCurrentCard({...currentCard, number: e.target.value})} /> {t('new_card_setting2.last')}
                            </dd>
                        </>
                        :
                        <>
                            <dt className="oripa-info-modal-dl-title clear-left">{t('new_card_setting2.cards1')}</dt>
                            <dd className="oripa-info-modal-dl-text">
                                <input type="text" className="oripa-info-modal-dl-input" value={currentCard.number} onChange={(e) => setCurrentCard({...currentCard, number: e.target.value})} /> {t('new_card_setting2.cards2')} 
                            </dd>
                        </>
                    }
                    <dt className="oripa-info-modal-dl-title clear-left">{t('new_card_setting2.points1')}</dt>
                    <dd className="oripa-info-modal-dl-text">
                        <input type="text" className="oripa-info-modal-dl-input" value={currentCard.rewardPoint} onChange={(e) => setCurrentCard({...currentCard, rewardPoint: e.target.value})} /> {t('new_card_setting2.points2')}
                    </dd>
                    <dt className="oripa-info-modal-dl-title clear-left">
                        <input type="radio" className="oripa-info-modal-dl-radio" name="psa" value="1" checked={currentCard.isPsaEnabled == "1"} onChange={(e) => setCurrentCard({...currentCard, isPsaEnabled: e.target.value})} />
                        {t('new_card_setting2.PSA1')}
                    </dt>
                    <dd className="oripa-info-modal-dl-text">
                        <input type="text" className="oripa-info-modal-dl-input" value={currentCard.psa} onChange={(e) => setCurrentCard({...currentCard, psa: e.target.value})} /> {t('new_card_setting2.PSA2')}
                    </dd>
                    <dt className="oripa-info-modal-dl-title clear-left">
                        <input type="radio" className="oripa-info-modal-dl-radio" name="psa" value="2" checked={currentCard.isPsaEnabled == "2"} onChange={(e) => setCurrentCard({...currentCard, isPsaEnabled: e.target.value})} />
                        {t('new_card_setting2.PSA3')}
                    </dt>
                    <dd className="oripa-info-modal-dl-text"></dd>
                </dl>
            </div>
            <div className="clearfix"></div>
            <div className="new-card-setting-modal-button">
            <button className="new-card-setting-modal-button-cancel" onClick={movePrevPage}>{t('new_card_setting2.back')}</button>
            <button className="new-card-setting-modal-button-add" onClick={submitRegister}>{t('new_card_setting2.next')}</button>
            </div>
        </Modal>
        </>
    );
}

export default NewCardSetting2;